import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        token: localStorage.getItem('token'),
        userPermissions: localStorage.getItem('userPermissions') != '' ? JSON.parse(localStorage.getItem('userPermissions')) : ["首页"], // 存储用户的权限信息
        userinfo: localStorage.getItem('userinfo') != '' ? JSON.parse(localStorage.getItem('userinfo')) : '',
        navIndex: localStorage.getItem('navIndex') != '' ? JSON.parse(localStorage.getItem('navIndex')) : [0, 1],
        crumbs: localStorage.getItem('crumbs') != '' ? JSON.parse(localStorage.getItem('crumbs')) : {
            path: '/main',
            title: '首页'
        }
    },
    mutations: {
        setToken: (state, token) => {
            state.token = token
            localStorage.setItem("token", token)
        },
        // 从后端获取用户权限信息并存储到store中
        fetchUserPermissions({ commit }) {
            // 这里应该调用后端接口获取用户权限信息
            // 假设我们得到了权限信息 ['admin', 'editor']
            const permissions = ['admin', 'editor']
            commit('setUserPermissions', permissions)
        },
        setUserPermissions(state, permissions) {
            if (permissions != '') {
                localStorage.setItem('userPermissions', JSON.stringify(permissions))
                state.userPermissions = permissions
            }
        },
        removeInfo: (state) => {
            localStorage.setItem("token", '')
            sessionStorage.setItem("userinfo", JSON.stringify(''))
            state.userinfo = {}
        },
        setNavIndex(state, data) {
            console.log(data)
            if (data != '') {
                localStorage.setItem('navIndex', JSON.stringify(data))
                state.navIndex = data
            }
        },
        setUserinfo(state, data) {
            if (data != '') {
                localStorage.setItem('userinfo', data)
                state.userinfo = JSON.parse(data)
            }
        },
        setCrumbs(state, data) {
            if (data != '') {
                localStorage.setItem('crumbs', data)
                state.crumbs = data
            }
        }
    }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js